import React from "react";
import { Trans, useTranslation } from "react-i18next";
import ReactPopup from "components/popup/ReactPopup";
import classNames from "classnames";
import StickerTopMore from "components/left/StickerTopMore";
import { ProfileImage } from "components/ImageHandle";
import Nickname from "components/contents/Nickname";
import { JAVASCRIPT_VOID } from "constant/config";

const StickerTop = (props) => {
	const { t } = useTranslation();

	const { sticker_top, home } = props;
	const sticker_top3 = sticker_top.slice(0, 3);
	
	if (sticker_top.length > 0) {
		return (
			<div className="rank-list">
				<h3>
					<Trans>Người ủng hộ</Trans>
				</h3>
				{home && (
					<ul>
						{sticker_top3.map((sticker, idx) => {
							return (
								<li
									key={idx}
									className={classNames({
										first: idx === 0,
										top: idx > 0,
									})}
								>
									<ProfileImage userId={sticker.user_id} className="thum" src={sticker.profile_image} />
									<Nickname
										item={{
											user_id: sticker.user_id,
											user_nick: sticker.user_nick,
										}}
									>
										<a href={JAVASCRIPT_VOID}>{sticker.user_nick}</a>
									</Nickname>
									<em>{idx === 0 ? t("CT") : (idx === 1 ? t("PCT") : t("TOP {{num}}", { num: idx + 1 }))}</em>
								</li>
							);
						})}
					</ul>
				)}
				<ReactPopup
					offsetX={255}
					offsetY={10}
					trigger={
						<button type="button" className="more" tip={t("Xem thêm")}>
							<span>
								<Trans>Xem thêm</Trans>
							</span>
						</button>
					}
				>
					{(close) => <StickerTopMore sticker_top={sticker_top} close={close} key="sticker_top" />}
				</ReactPopup>
			</div>
		);
	} else {
		return null;
	}
}

export default StickerTop;